module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.search != '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "id": "hello",
      "items": _vm.factoryList,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.address))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditFactory(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteFactory(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}